<template>
  <div id="app">
    <span hidden>{{ checkStatusLogin }}</span>
    <div class="p-grid" style="padding-right: 20px">
      <AppSubmenu
        class="layout-menu clearfix"
        :items="model"
        :layoutMode="layoutMode"
        :menuActive="active"
        :root="true"
        :parentMenuItemActive="true"
        @menuitem-click="onMenuItemClick"
        @root-menuitem-click="onRootMenuItemClick"
      />
      <OverlayPanel ref="op" :showCloseIcon="false">
        <p @click="$router.push('/update').catch((err) => {})" class="pointer">
          รายการที่ต้องปรับปรุงข้อมูล
        </p>
        <hr />
        <p @click="logout()" class="pointer">{{ $t("Logout") }}</p>
      </OverlayPanel>
    </div>

    <!-- Login modal -->
    <Dialog
      :modal="true"
      :visible.sync="loginModal"
      :style="{ width: '350px' }"
      :header="$t('login_title')"
    >
      <div class="confirmation-content">
        <label>{{ $t("login_subtitle") }}</label>
        <div class="p-fluid p-mt-5">
          <div class="p-field">
            <label for="username">{{ $t("login_username") }}</label>
            <InputText
              id="username"
              type="text"
              v-model="username"
              required="true"
              autofocus
              :class="{ 'p-invalid': error_username && !username }"
            />
            <small class="p-invalid" v-if="error_username && !username">{{
              $t("login_validate_username")
            }}</small>
          </div>
          <div class="p-field">
            <label for="password">{{ $t("login_password") }}</label>
            <InputText
              id="password"
              type="password"
              v-model="password"
              required="true"
              autofocus
              :class="{ 'p-invalid': error_password && !password }"
            />
            <small class="p-invalid" v-if="error_password && !password">{{
              $t("login_validate_password")
            }}</small>
          </div>
          <small class="p-invalid" v-if="login_failed == true">{{
            $t("login_invalid")
          }}</small>
        </div>
      </div>
      <template #footer>
        <Button
          :label="$t('cancelBtn')"
          icon="pi pi-times"
          class="p-button-text"
          @click="clearData()"
        />
        <Button
          :label="$t('login_confirm')"
          icon="pi pi-check"
          class="p-button-text"
          @click="checkLogin()"
        />
      </template>
    </Dialog>

    <!-- Add suggestion modal -->
    <Dialog
      :modal="true"
      :visible.sync="suggestionModal"
      :style="{ width: '700px' }"
      :header="$t('suggestion_modal_title')"
    >
      <div class="confirmation-content">
        <label>{{ $t("suggestion_modal_subtitle") }}</label>
        <div class="p-fluid p-mt-5">
          <div class="p-formgrid p-grid">
            <div class="p-field p-col-5">
              <label for="suggest_name"
                >{{ $t("suggest_name") }}
                <span class="required-input">*</span></label
              >
              <InputText
                id="suggest_name"
                type="text"
                v-model="suggest_name"
                required="true"
                autofocus
                :class="{ 'p-invalid': error_suggest_name && !suggest_name }"
              />
              <small
                class="p-invalid"
                v-if="error_suggest_name && !suggest_name"
                >{{ $t("suggest_validate_name") }}</small
              >
            </div>

            <div class="p-field p-col-7">
              <div class="p-formgrid p-grid p-mt-1">
                <div class="p-col-4 p-mt-4">
                  <Dropdown
                    v-model="selectedType"
                    :options="mailPhone"
                    optionLabel="name"
                  >
                    <template #value="mailPhone">
                      <div v-if="mailPhone.value">
                        <div>{{ mailPhone.value.name }}</div>
                      </div>
                      <span v-else>
                        {{ mailPhone.placeholder }}
                      </span>
                    </template>
                    <template #option="mailPhone">
                      <div>{{ mailPhone.option.name }}</div>
                    </template>
                  </Dropdown>
                </div>
                <div class="p-col p-mt-5">
                  <InputText
                    v-if="selectedType.id == 'phone'"
                    id="suggest_email_phone"
                    type="text"
                    @input="acceptNumber"
                    v-model="suggest_email_phone"
                    required="true"
                    autofocus
                    :class="{
                      'p-invalid':
                        error_suggest_email_phone && !suggest_email_phone,
                    }"
                  />
                  <InputText
                    v-else
                    id="suggest_email_phone"
                    type="text"
                    v-model="suggest_email_phone"
                    required="true"
                    autofocus
                    :class="{
                      'p-invalid':
                        (error_suggest_email_phone && !suggest_email_phone) ||
                        error_suggest_email_format == true,
                    }"
                  />
                  <small
                    class="p-invalid"
                    v-if="error_suggest_email_phone && !suggest_email_phone"
                    >{{ $t("suggest_validate_emailphone") }}</small
                  >
                  <small
                    class="p-invalid"
                    v-if="error_suggest_email_format == true"
                    >กรุณาระบุอีเมลให้ถูกต้อง</small
                  >
                  <small
                    class="p-invalid"
                    v-if="error_suggest_phone_format == true"
                    >กรุณาระบุเบอร์โทรศัพท์ให้ถูกต้อง</small
                  >
                </div>
              </div>
            </div>
          </div>
          <div class="p-fluid">
            <div class="p-field">
              <label for="suggest_topic"
                >{{ $t("suggest_topic") }}
                <span class="required-input">*</span></label
              >
              <InputText
                id="suggest_topic"
                type="text"
                v-model="suggest_topic"
                required="true"
                autofocus
                :class="{ 'p-invalid': error_suggest_topic && !suggest_topic }"
              />
              <small
                class="p-invalid"
                v-if="error_suggest_topic && !suggest_topic"
                >{{ $t("suggest_validate_topic") }}</small
              >
            </div>
            <div class="p-field">
              <label for="suggest_detail"
                >{{ $t("suggest_detail") }}
                <span class="required-input">*</span></label
              >
              <Textarea
                id="suggest_detail"
                type="text"
                rows="5"
                v-model="suggest_detail"
                required="true"
                autofocus
                :class="{
                  'p-invalid': error_suggest_detail && !suggest_detail,
                }"
              />
              <small
                class="p-invalid"
                v-if="error_suggest_detail && !suggest_detail"
                >{{ $t("suggest_validate_detail") }}</small
              >
            </div>
          </div>
        </div>
      </div>
      <template #footer>
        <Button
          :label="$t('cancelBtn')"
          icon="pi pi-times"
          class="p-button-text"
          @click="clearData()"
        />
        <Button
          :label="$t('saveBtn')"
          icon="pi pi-check"
          class="p-button-text"
          @click="checkSuggestion()"
        />
      </template>
    </Dialog>

    <!-- Are you sure for close this modal -->
    <Dialog
      :modal="true"
      :header="$t('ConfirmCloseModal')"
      :visible.sync="displayConfirmationCloseModal"
      :style="{ width: '350px' }"
    >
      <div class="confirmation-content p-mt-3">
        <span>{{ $t("ConfirmCloseModalSub") }}</span>
      </div>
      <template #footer>
        <Button
          :label="$t('cancelBtn')"
          icon="pi pi-times"
          @click="displayConfirmationCloseModal = false"
          class="p-button-text"
        />
        <Button
          :label="$t('confirmBtn')"
          icon="pi pi-check"
          @click="closeAllModal()"
          class="p-button-text"
          autofocus
        />
      </template>
    </Dialog>

    <Toast />
  </div>
</template>

<script>
import AppSubmenu from "./AppSubmenu";

export default {
  props: {
    layoutMode: String,
  },
  data() {
    return {
      active: true,
      loginModal: false,
      username: "",
      password: "",
      fullname: "",
      position: "",
      error_username: false,
      error_password: false,
      checkStatusLogin: "",
      login_success: false,
      login_failed: false,

      suggestionModal: false,
      suggest_name: "",
      suggest_email_phone: "",
      suggest_topic: "",
      suggest_detail: "",
      error_suggest_name: false,
      error_suggest_email_phone: false,
      error_suggest_email_format: false,
      error_suggest_phone_format: false,
      error_suggest_topic: false,
      error_suggest_detail: false,
      model: [],

      displayConfirmationCloseModal: false,

      mailPhone: [
        { id: "mail", name: "อีเมล" },
        { id: "phone", name: "เบอร์โทรศัพท์" },
      ],
      selectedType: { id: "mail", name: "อีเมล" },
    };
  },
  watch: {
    loginModal(val) {
      if (val == false) {
        this.clearData();
      }
    },

    checkStatusLogin(val) {
      if (val == "failed login") {
        this.login_failed = true;
      } else {
        this.$toast.add({
          severity: "success",
          summary: "เข้าสู่ระบบสำเร็จ",
          detail: "ยินดีต้อนรับ",
          life: 300000,
        });
        localStorage.setItem("session", val.user_fullname);
        this.loginModal = false;
        location.reload();
      }
    },

    suggestionModal(val) {
      if (val == false) {
        if (
          this.suggest_name != "" &&
          this.suggest_email_phone != "" &&
          this.suggest_topic != "" &&
          this.suggest_detail != ""
        ) {
          this.displayConfirmationCloseModal = true;
        } else {
          this.clearData();
        }
      }
    },

    displayConfirmationCloseModal(val) {
      if (val == true) {
        this.suggestionModal = true;
      }
    },

    suggest_email_phone(val) {
      if (val == "") {
        this.error_suggest_email_format = false;
      }
    },

    selectedType(val) {
      console.log("Select " + val.id);
      this.suggest_email_phone = "";
    },
  },
  created() {
    var check = localStorage.getItem("data");
    if (
      check != null &&
      JSON.parse(localStorage.getItem("data")) != "failed login"
    ) {
      this.login_success = true;
      this.fullname = JSON.parse(localStorage.getItem("data")).user_fullname;
      this.position = JSON.parse(localStorage.getItem("data")).organize_name;
    } else {
      this.login_success = false;
      this.fullname = "";
      this.position = "";
    }
  },
  methods: {
    logoutSystem() {
      localStorage.removeItem("userSession");
      window.location = "/login";
    },

    acceptNumber() {
      var x = this.suggest_email_phone
        .replace(/\D/g, "")
        .match(/(\d{0,3})(\d{0,3})(\d{0,4})/);
      this.suggest_email_phone = !x[2]
        ? x[1]
        : x[1] + "-" + x[2] + (x[3] ? "-" + x[3] : "");
    },

    closeAllModal() {
      console.log("Close and don`t save data");
      this.suggestionModal = false;
      this.displayConfirmationCloseModal = false;
      this.clearData();
    },

    toggle(event) {
      this.$refs.op.toggle(event);
    },

    onMenuItemClick(event) {
      this.$emit("menuitem-click", event);
      if (
        localStorage.getItem("session") == null &&
        event.item.label == "ข้อเสนอแนะ"
      ) {
        this.suggestionModal = true;
      } else {
        console.log("admin level");
      }
    },
    onRootMenuItemClick(event) {
      this.$emit("root-menuitem-click", event);
    },

    async checkLogin() {
      if (this.username == "" || this.password == "") {
        if (this.username == "") {
          this.error_username = true;
        }
        if (this.password == "") {
          this.error_password = true;
        }
      } else {
        await this.axios
          .post(`${this.$url_service}/get/login`, {
            body: {
              username: this.username,
              password: this.password,
            },
          })
          .then((response) => {
            (this.checkStatusLogin = response.data.data),
              localStorage.setItem("data", JSON.stringify(response.data.data));
          });
      }
    },

    async checkSuggestion() {
      if (
        this.suggest_name == "" ||
        this.suggest_email_phone == "" ||
        this.suggest_topic == "" ||
        this.suggest_detail == ""
      ) {
        if (this.suggest_name == "") {
          this.error_suggest_name = true;
        }
        if (this.suggest_email_phone == "") {
          this.error_suggest_email_phone = true;
        }
        if (this.suggest_topic == "") {
          this.error_suggest_topic = true;
        }
        if (this.suggest_detail == "") {
          this.error_suggest_detail = true;
        }
      } else {
        var check;
        if (this.selectedType.id == "mail") {
          var re =
            /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
          check = re.test(this.suggest_email_phone);
          console.log("Email validate : " + check);
        }

        if (check == false) {
          this.error_suggest_email_format = true;
        } else {
          const receive = new Date();
          const ye1 = new Intl.DateTimeFormat("en", { year: "numeric" }).format(
            receive
          );
          const mo1 = new Intl.DateTimeFormat("en", {
            month: "2-digit",
          }).format(receive);
          const da1 = new Intl.DateTimeFormat("en", { day: "2-digit" }).format(
            receive
          );
          const receivedate = `${ye1}-${mo1}-${da1}`;

          let result = await this.axios
            .post(`${this.$url_service}/get/suggestion`, {
              body: {
                topic: "add-suggestion",
                date: receivedate,
                name: this.suggest_name,
                contact: this.suggest_email_phone,
                stopic: this.suggest_topic,
                detail: this.suggest_detail,
              },
            })
            .then((resp) => {
              return resp;
            });
          if (result) {
            this.suggestionModal = false;
            this.$toast.add({
              severity: "success",
              summary: "เพิ่มข้อเสนอแนะสำเร็จ",
              detail: "สำหรับผู้ใช้ทั่วไป",
              life: 3000,
            });
            this.clearData();
          } else {
            this.$toast.add({
              severity: "danger",
              summary: "เพิ่มข้อเสนอแนะไม่สำเร็จ",
              detail: "มีข้อผิดพลาด",
              life: 3000,
            });
          }
        }
      }
    },

    clearData() {
      this.username = "";
      this.password = "";
      this.login_failed = false;
      this.error_username = false;
      this.error_password = false;

      this.suggest_name = "";
      this.suggest_email_phone = "";
      this.suggest_topic = "";
      this.suggest_detail = "";
      this.selectedType = { id: "mail", name: "อีเมล" };
      this.error_suggest_name = false;
      this.error_suggest_email_phone = false;
      this.error_suggest_topic = false;
      this.error_suggest_detail = false;
    },

    logout() {
      localStorage.removeItem("session");
      localStorage.removeItem("data");
      this.$router.push("/statistic-disaster");
      location.reload();
    },
  },

  mounted() {
    //this.$router.push("/map-disaster");
    this.model = [
      {
        label: "แสดงตำแหน่ง : แผนที่",
        icon: "pi pi-fw pi-map-marker",
        to: "/map-disaster",
      },
      {
        label: "ข้อมูลผู้ใช้งานทั่วไป",
        icon: "pi pi-fw pi-users",
        to: "/information/user",
      },
      {
        label: "ข้อมูลร้านค้า/บริการ",
        icon: "pi pi-fw pi-shopping-cart",
        to: "/information/shop",
      },
      {
        label: "ข้อมูลระบบพื้นฐาน",
        icon: "pi pi-fw pi-circle-off",
        to: "/information/system",
      }
    ];
  },
  components: {
    AppSubmenu: AppSubmenu,
  },
};
</script>

<style scoped>
.login-text {
  color: white;
  margin-left: auto;
  font-size: 16px;
}

.p-grid {
  margin-right: 0rem;
}
</style>
